import { isEmpty } from '@/pages/intelligence/utils/commonUtils';

import type { IEntity } from '../types';

/**
 * 获取实体主键列表
 * @param entities 实体
 * @param entityKey 实体主键字段名
 * @returns 实体主键列表
 */
export function getEntitiesKeys(entities: IEntity[], entityKey: string): string[] {
  if (!Array.isArray(entities)) return [];
  const keys: string[] = [];
  for (const entity of entities) {
    const key = entity?.[entityKey];
    if (isEmpty(key)) continue;
    keys.push(key);
  }
  return keys;
}
